import { addCustomPanelMenuItem } from '../menu-item/add-custom-panel-menu-item';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { editCustomPanelMenuItem } from '../menu-item/edit-custom-panel-menu-item';
import { removeCustomPanelMenuItem } from '../menu-item/remove-custom-panel-menu-item';

export const customPanelMenuList: Array<ContextMenuList> = [
	editCustomPanelMenuItem(),
	addCustomPanelMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	removeCustomPanelMenuItem()
];
